import React from 'react';
import { withRouter } from 'dva/router';
import { connect } from 'dva';
import { Form, Input, Button } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import styles from './styles.less';
import helpers from '../../utils/helpers';

const FormItem = Form.Item;

class FirstLogin extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
  };

  getFirstLoginHeaders() {
    return (<div>
      <h2><FormattedMessage id="Components.FirstLogin.Header" /></h2>
      <p><FormattedMessage id="Components.FirstLogin.Text1" /></p>
      <p><FormattedMessage id="Components.FirstLogin.Text2" /></p>
      <p><FormattedMessage id="Components.FirstLogin.Text3" /></p>
      <p><FormattedMessage id="Components.FirstLogin.Text4" /></p>
      <ul>
        <li><FormattedMessage id="Components.FirstLogin.Text.Password1" /></li>
        {/* <li><FormattedMessage id="Components.FirstLogin.Text.Password2" /></li> */}
        {/* <li><FormattedMessage id="Components.FirstLogin.Text.Password3" /></li> */}
        {/* <li><FormattedMessage id="Components.FirstLogin.Text.Password4" /></li> */}
      </ul>

      <p><FormattedMessage id="Components.FirstLogin.Text5" /></p>
      <p><FormattedMessage id="Components.FirstLogin.Text6" /></p>
    </div>);
  }

  compareToFirstPassword(rule, value, callback) {
    const form = this.props.form;
    const password = form.getFieldValue('password');

    if (value && value !== password) {
      callback(this.props.intl.formatMessage({ id: 'Components.FirstLogin.PasswordMismatchError' }));
    } else {
      callback();
    }
  }

  checkPassword(rule, value, callback) {
    const form = this.props.form;
    const password = form.getFieldValue('password');

    if (!helpers.isValidPassword(password)) {
      callback(this.props.intl.formatMessage({ id: 'Common.ConfirmationPasswordSecureRule' }));
    } else {
      callback();
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    const { token, email } = this.props.app.firstLogin;
    this.props.form.validateFieldsAndScroll((err, values) => {
      const { password, password_confirmation } = values;
      if (!err) {
        this.props.dispatch({
          type: 'app/changePassword',
          payload: { email, token, password, password_confirmation },
        }).then(() => {
          this.props.dispatch({
            type: 'app/logout',
          });
        }).catch((error) => {
          helpers.processException(error);
        });
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className={styles.firstLoginForm}>
        {this.props.app.firstVisit ?
          this.getFirstLoginHeaders() :
          <h2><FormattedMessage id="Component.Dashboard.ChangePassword" /></h2>}
        <Form onSubmit={this.handleSubmit.bind(this)} layout="vertical">
          <FormItem label={<FormattedMessage id="Components.FirstLogin.PasswordLabel" />}>
            {getFieldDecorator('password', {
              rules: [{
                required: true,
                message: this.props.intl.formatMessage({ id: 'Components.FirstLogin.PasswordError' }),
              }, {
                validator: this.checkPassword.bind(this),
              }],
            })(
              <Input maxLength={255} type="password" />,
            )}
          </FormItem>
          <FormItem label={<FormattedMessage id="Components.FirstLogin.PasswordConfirmLabel" />}>
            {getFieldDecorator('password_confirmation', {
              rules: [{
                required: true,
                message: this.props.intl.formatMessage({ id: 'Components.FirstLogin.PasswordConfirmError' }),
              }, {
                validator: this.compareToFirstPassword.bind(this),
              }],
              pattern: '',
            })(
              <Input maxLength={255} type="password" />,
            )}
          </FormItem>
          <FormItem>
            <Button type="primary" htmlType="submit" className={styles.loginFormButton}>
              Submit
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default withRouter(connect(({ app }) => ({ app }))(Form.create()(injectIntl(FirstLogin))));



// WEBPACK FOOTER //
// ./src/components/FirstLogin/FirstLogin.js